var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditDocIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 44.6672V89.3333H40.7515H81.503V78.5638V67.7943L79.3582 66.2801L77.2133 64.7416V75.0392V85.363H40.7515H4.28963V44.6672V3.97134H40.7515H77.2133V29.3561V64.7416L79.3582 66.2801C80.4568 67.0499 81.422 67.7943 81.503 67.7943C81.5829 67.7943 81.503 44.6165 81.503 28.7849V3.57628e-06H40.7515H0V44.6672Z",
    fill: "#F7931E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 11.0796V13.3837H91.6392H95.3251V38.9012V75.395L96.9308 76.4851C97.9515 77.1691 99.6348 78.564 99.8616 78.6652C100.173 78.843 99.8616 62.4192 99.8616 38.3194V9.33333H93.9075H80V11.0796Z",
    fill: "#F7931E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3077 32.6667V42.6667H54.6154H56.9231V32.6667V22.6667H54.6154H52.3077V32.6667Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5385 36V42.6667H43.0769H44.6154V36V29.3333H43.0769H41.5385V36V36Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8462 66V68H42.3077H70.7692V66V64H42.3077H13.8462V66V66Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4656 85.2261V96.0002H56.9231H18.3806V94.0002V88.1586H16.6866H13.8462V96.0002V100H56.9231H100V88.7749V77.5509L98.1006 76.2264C97.0237 75.5265 96.0035 74.8265 95.8334 74.6765C95.55 74.501 95.4656 76.6254 95.4656 85.2261Z",
    fill: "#F7931E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8462 78V80H42.3077H70.7692V78V76H42.3077H13.8462V78V78Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3863 42.9002L53.3327 60.1334L68.4328 53.7952L97 26.7331L88.3346 15L60.3863 42.9002Z",
    stroke: "#29ABE2",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 23L89 34",
    stroke: "#29ABE2",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDocIcon);
export default __webpack_public_path__ + "static/media/EditDocIcon.b276014c94f8fc95e33e4b44a1f482ba.svg";
export { ForwardRef as ReactComponent };